import { Button, Dialog, Dropdown, HStack, Text } from 'components/ui';
import { useAiEditorContext } from '../ai-editor.context';
import { useState } from 'react';
import { SVG } from 'components/svg';
import { Icons } from 'assets';

export const AiEditorHeader = () => {
  const { modes, activeMode, handleModeSelect, isGenerating } =
    useAiEditorContext();

  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

  return (
    <HStack align="center" justify="space-between">
      <Dialog.Title>ИИ-редактор</Dialog.Title>
      <Dialog.Description hidden>
        Модальное окно для редактирования текста с помощью ИИ
      </Dialog.Description>

      <Dropdown.Root open={dropdownOpen} onOpenChange={setDropdownOpen}>
        <Dropdown.Trigger asChild>
          <Button
            rightIcon={
              <SVG src={Icons.Chevron} props={{ isMirror: dropdownOpen }} />
            }
            mode="accent"
            variant="ghost"
            size="xs"
            style={isGenerating ? { pointerEvents: 'none' } : undefined}
          >
            Режим: {activeMode?.text ?? '—'}
          </Button>
        </Dropdown.Trigger>

        <Dropdown.Content align="end">
          {modes.map((mode) => (
            <Dropdown.CheckboxItem
              key={mode.value}
              onSelect={() => handleModeSelect(mode)}
              checked={activeMode?.value === mode.value}
            >
              <Text>{mode.text}</Text>
              <Dropdown.ItemIndicator>
                <SVG src={Icons.Check} />
              </Dropdown.ItemIndicator>
            </Dropdown.CheckboxItem>
          ))}
        </Dropdown.Content>
      </Dropdown.Root>
    </HStack>
  );
};
